import React, { createContext, useContext, useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const StripeContext = createContext(null);

export const useStripe = () => {
  const context = useContext(StripeContext);
  if (!context) {
    return null;
  }
  return context;
};

export const StripeProvider = ({ children }) => {
  const [stripe, setStripe] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Initialize Stripe
    const initStripe = async () => {
      try {
        const stripeInstance = await loadStripe(process.env.REACT_APP_STRIPE_API_KEY);
        setStripe(stripeInstance);
      } catch (error) {
        console.error('Failed to initialize Stripe:', error);
      } finally {
        setIsLoading(false);
      }
    };
    initStripe();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <StripeContext.Provider value={stripe}>
      {children}
    </StripeContext.Provider>
  );
}; 